<!--
 * @Descripttion: 重置密码
 * @Date: 2024-11-15 10:33:38
-->
<template>
  <BaseDialog
    class="employee-management-add"
    title="重置密码"
    width="450px"
    :model-value="true"
  >
    <BaseTextContent>
      <BaseForm
        ref="formRef"
        :model="formData"
        :rules="rules"
        label-position="top"
      >
        <BaseFormItem label="请输入新密码" prop="password">
          <BaseInput
            style="width: 100%"
            type="password"
            autocomplete="off"
            placeholder="请输入新密码"
            show-password
            :clearable="true"
            :maxlength="8"
            v-model="formData.password"
          ></BaseInput>
        </BaseFormItem>
        <BaseFormItem label="请再次输入新密码" prop="passwordTwo">
          <BaseInput
            style="width: 100%"
            type="password"
            autocomplete="off"
            placeholder="请再次输入新密码"
            show-password
            :clearable="true"
            :maxlength="8"
            v-model="formData.passwordTwo"
          ></BaseInput>
        </BaseFormItem>
      </BaseForm>
    </BaseTextContent>
    <template #footer>
      <BaseButton type="default" @click="onCancel">返回</BaseButton>
      <BaseButton @click="onConfirm">保存</BaseButton>
    </template>
  </BaseDialog>
</template>

<script lang="tsx" setup>
import { ref, withDefaults, defineProps, defineEmits } from 'vue';
import {
  BaseDialog,
  BaseForm,
  BaseFormRef,
  BaseFormItem,
  BaseInput,
  BaseFormProps,
  BaseTextContent,
  BaseButton,
  XrkMessage
} from 'xrk-components';
import { validatorPassword } from '@/utils/validator';
import { setAPassword2 } from '@/common/data-source/user/apis';

const props = withDefaults(
  defineProps<{
    remove?: () => void;
  }>(),
  {}
);
const emits = defineEmits(['success']);

const formRef = ref<BaseFormRef>();
const formData = ref({
  password: '',
  passwordTwo: ''
});
const rules = ref<BaseFormProps['rules']>({
  password: [
    {
      required: true,
      trigger: 'blur',
      validator: (...arg) => validatorPassword(...arg, '请输入新密码')
    }
  ],
  passwordTwo: [
    {
      required: true,
      trigger: 'blur',
      validator: (_rule, value, callback) => {
        if (!value) {
          callback(new Error('请再次输入新密码'));
        } else if (formData.value.password !== value) {
          callback(new Error('您的新密码和确认密码不一致，请重新输入'));
        } else {
          callback();
        }
      }
    }
  ]
});

const onCancel = () => {
  props.remove();
};

const onConfirm = async () => {
  try {
    await formRef.value.validate();
    await setAPassword2(formData.value);
    onCancel();
    XrkMessage.success('用户重置密码成功');
    emits('success');
  } catch (error) {
    console.log(error);
  }
};
</script>

<style lang="scss">
// .employee-management-add {}
</style>
